'use client';
import Image from 'next/image';

const PeopleCenteredImagesPath = '/images/PeopleCentered';
const card1ImagePath = `${PeopleCenteredImagesPath}/PeopleCentered1.webp`;
const card2ImagePath = `${PeopleCenteredImagesPath}/PeopleCentered2.webp`;

const Block1 = () => (
  <div className="bg-stonerwhite gap-4 rounded-lg p-4 shadow-lg md:p-6 lg:p-8 flex h-full w-full flex-col items-center text-center">
    <h3 className="text-policeblue-dark font-bold">Au-delà des algorithmes</h3>

    <div className="text-charcoal gap-4 font-semibold md:flex-row flex flex-col">
      <p>
        Au-delà des algorithmes et des correspondances automatisées en fonction des derniers
        mots-clés tendance, nous plaçons l&apos;humain au centre de notre démarche.
      </p>

      <p>
        Si l&apos;intelligence artificielle constitue un appui technique précieux, elle ne suffit
        pas à créer les liens de confiance indispensables à un recrutement réussi.
      </p>
    </div>
  </div>
);

const Block2 = () => (
  <div className="gap-4 md:flex-row flex h-full w-full flex-col items-center justify-between">
    <div className="gap-4 pr-4 md:w-7/12 md:pr-6 lg:prx-8 flex h-full w-full flex-col">
      <h3 className="text-stonerwhite">Une mise en adéquation personnalisée</h3>

      <p className="text-verylightgrey text-justify">
        Cette connaissance fine des attentes permet une mise en adéquation subtile entre les profils
        et les besoins.
      </p>

      <p className="text-verylightgrey text-justify">
        Elle favorise les recrutements durables, fondés sur la compatibilité humaine autant que sur
        les compétences.
      </p>
    </div>

    <div className="md:pl-4 md:pb-4 rounded-lg md:w-5/12 h-full w-full">
      <Image
        src={`${card1ImagePath || ''}`}
        alt="Two people talking at each other"
        className="rounded-lg shadow-lg h-full w-full"
        width={1920}
        height={1440}
      />
    </div>
  </div>
);

const Block3 = () => (
  <div className="gap-4 md:flex-row flex w-full flex-col items-center justify-between">
    <div className="md:pr-4 md:pb-4 rounded-lg md:w-5/12 h-full w-full">
      <Image
        src={`${card2ImagePath || ''}`}
        alt="Two people talking at each other"
        className="rounded-lg shadow-lg h-full w-full"
        width={1920}
        height={1440}
      />
    </div>

    <div className="gap-4 sm:pl-4 md:w-7/12 md:pl-6 lg:pl-8 flex flex-col">
      <h3 className="text-stonerwhite">
        Une écoute active auprès des talents de 45&nbsp;ans et plus et des entreprises
      </h3>

      <p className="text-verylightgrey text-justify">
        Notre approche repose sur un dialogue constant avec les talents de 45&nbsp;ans et plus et
        les entreprises, afin de comprendre leurs critères de recherche et de sélection, leurs
        exigences.
      </p>

      <p className="text-verylightgrey text-justify">
        Cette relation de confiance nous permet d&apos;ajuster finement chaque proposition, en phase
        avec leurs besoins réels et leurs ambitions.
      </p>
    </div>
  </div>
);

const Block4 = () => (
  <div className="bg-stonerwhite gap-4 rounded-lg p-4 md:p-6 lg:p-8 flex h-full w-full flex-col text-center">
    <h3 className="text-policeblue-dark font-bold">Technologie et intelligence relationnelle</h3>

    <p className="text-charcoal font-semibold">
      En conjuguant technologie et intelligence relationnelle, nous construisons des relations
      professionnelles porteuses de sens, au service d&apos;un marché de l&apos;emploi plus juste et
      plus humain.
    </p>
  </div>
);

const PeopleCentered = () => (
  <section className="bg-policeblue-dark p-4 sm:p-8 md:p-10 lg:p-12 flex flex-col items-center">
    <div className="gap-4 md:gap-6 lg:gap-8 max-w-6xl m-auto mx-auto flex flex-col items-center">
      <h2 className="text-stonerwhite">L&apos;humain au cœur du processus</h2>

      <Block1 />
      <Block2 />
      <Block3 />
      <Block4 />
    </div>
  </section>
);

export default PeopleCentered;
